import request from '@/utils/request'

export function login(data) {
  return request({ url: '/api/admin/auth/login', method: 'post', data })
}

// 用户列表/新建/编辑：query/body 透传 countryCode（'NG'/'GH'，编辑可用 'unset' 恢复未设置）
export function getUserList(params) {
  return request({ url: '/api/admin/users', method: 'get', params })
}

export function createUser(data) {
  return request({ url: '/api/admin/users', method: 'post', data })
}

export function updateUser(id, data) {
  return request({ url: `/api/admin/users/${id}`, method: 'put', data })
}

export function updateUserStatus(id, status) {
  return request({ url: `/api/admin/users/${id}/status`, method: 'put', data: { status } })
}

export function resetPassword(id, newPassword) {
  return request({ url: `/api/admin/users/${id}/reset-password`, method: 'post', data: { newPassword } })
}

export function updateSaReviewStatus(saId, reviewStatus, reason) {
  return request({ url: `/api/admin/sa/${saId}/review-status`, method: 'put', data: { reviewStatus, reason } })
}

// 门店启停（AD-STR-R5）：data = { status, reason, effectiveAt }，GH 停用必填 effectiveAt，NG 不传
export function updateStoreStatus(storeId, data) {
  return request({ url: `/api/admin/stores/${storeId}/status`, method: 'put', data })
}

// 门店营业状态变更（AD-STR-N1）：data = { operatingStatus: 'open'|'temporarily_closed', reason }
export function updateStoreOperatingStatus(storeId, data) {
  return request({ url: `/api/admin/stores/${storeId}/operating-status`, method: 'post', data })
}

// 商户注册证明上传（AD-MCH-N1，GH）：form-data file -> { url }（7 天签名 URL，落库由后端剥离签名）
export function uploadRegistrationProof(file) {
  const formData = new FormData()
  formData.append('file', file)
  return request({
    url: '/api/admin/merchants/upload-registration-proof',
    method: 'post',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

// 商户脱敏导出（AD-MCH-N2）：query 同列表筛选，返回 xlsx 文件流
export function exportMerchants(params) {
  return request({ url: '/api/admin/merchants/export', method: 'get', params, responseType: 'blob' })
}

// 门店脱敏导出（AD-STR-N2）：query 同列表筛选，返回 xlsx 文件流
export function exportStores(params) {
  return request({ url: '/api/admin/stores/export', method: 'get', params, responseType: 'blob' })
}

export function logout() {
  return request({ url: '/api/admin/auth/logout', method: 'post' })
}

export function getUserInfo() {
  return request({ url: '/api/admin/auth/userinfo', method: 'get' })
}

export function listRoles() {
  return request({ url: '/api/admin/permissions/roles', method: 'get' })
}

export function createRole(data) {
  return request({ url: '/api/admin/permissions/roles', method: 'post', data })
}

export function updateRole(roleId, data) {
  return request({ url: `/api/admin/permissions/roles/${roleId}`, method: 'patch', data })
}

export function listAllMenus() {
  return request({ url: '/api/admin/permissions/menus', method: 'get' })
}

export function listAllPermissions() {
  return request({ url: '/api/admin/permissions/all', method: 'get' })
}

export function getRoleAssignment(roleId) {
  return request({ url: `/api/admin/permissions/roles/${roleId}`, method: 'get' })
}

export function assignRolePermissions(roleId, data) {
  return request({ url: `/api/admin/permissions/roles/${roleId}`, method: 'put', data })
}
